import { useState } from "react";
import { Box, Button, Modal, Typography, IconButton } from "@mui/material";
import instance from "../../../apiServices/instance";
import CloseIcon from "@mui/icons-material/Close";

const style = {
	position: "absolute",
	top: "50%",
	left: "50%",
	transform: "translate(-50%, -50%)",
	width: 800,
	bgcolor: "background.paper",
	borderRadius: "0.5rem",
	boxShadow: 24,
	padding: "2rem 3rem",
	outline: "none",
};

const inputStyle = {
	width: "100%",
	padding: "10px",
	border: "1px solid #ccc",
	borderRadius: "4px",
	fontSize: "1rem",
};

const AddCompanyManuallyModal = ({
	showModal,
	closeModal,
	closeAddCompanyModal,
	fetchCompanies,
}) => {
	const [companyName, setCompanyName] = useState("");
	const [firstName, setFirstName] = useState("");
	const [lastName, setLastName] = useState("");
	const [email, setEmail] = useState("");

	const handleSubmit = async () => {
		try {
			const res = await instance.post("/api/company-info/add-company", {
				companyName,
				teamDetails: [
					{
						name: `${firstName} ${lastName}`,
						email,
						mainContact: true,
					},
				],
				status: "Onboarding Email Sent",
			});
			if (res.status === 201) {
				await fetchCompanies();
				closeModal();
				closeAddCompanyModal();
			}
		} catch (error) {
			console.log("Error in onboarding client manually: ", error);
		}
	};

	return (
		<Modal open={showModal} onClose={closeModal}>
			<Box sx={style}>
				{/* Close Button */}
				<IconButton
					aria-label='close'
					onClick={closeModal}
					sx={{ position: "absolute", top: 8, right: 8 }}>
					<CloseIcon />
				</IconButton>

				{/* Company Details */}
				<Typography
					variant='h6'
					fontWeight='bold'
					sx={{ marginBottom: "1rem" }}>
					Company Details
				</Typography>

				<Box
					sx={{
						display: "flex",
						flexDirection: "column",
						gap: "0.5rem",
						marginBottom: "1rem",
						width: "70%",
					}}>
					<label htmlFor='companyName'>Company Name</label>
					<input
						type='text'
						id='companyName'
						value={companyName}
						onChange={(e) => setCompanyName(e.target.value)}
						style={inputStyle}
					/>
				</Box>

				{/* Contact Details */}
				<Typography
					variant='h6'
					fontWeight='bold'
					sx={{ marginBottom: "1rem" }}>
					Contact Details
				</Typography>

				<Box
					sx={{
						display: "flex",
						gap: "1rem",
						marginBottom: "1rem",
						width: "80%",
					}}>
					<Box
						sx={{
							display: "flex",
							flexDirection: "column",
							flex: 1,
						}}>
						<label htmlFor='firstName'>First Name</label>
						<input
							type='text'
							id='firstName'
							value={firstName}
							onChange={(e) => setFirstName(e.target.value)}
							style={inputStyle}
						/>
					</Box>
					<Box
						sx={{
							display: "flex",
							flexDirection: "column",
							flex: 1,
						}}>
						<label htmlFor='lastName'>Last Name</label>
						<input
							type='text'
							id='lastName'
							value={lastName}
							onChange={(e) => setLastName(e.target.value)}
							style={inputStyle}
						/>
					</Box>
				</Box>

				<Box
					sx={{
						display: "flex",
						flexDirection: "column",
						marginBottom: "2rem",
						width: "80%",
					}}>
					<label htmlFor='email'>Email Address</label>
					<input
						type='email'
						id='email'
						value={email}
						onChange={(e) => setEmail(e.target.value)}
						style={inputStyle}
					/>
				</Box>

				{/* Buttons */}
				<Box sx={{ display: "flex", gap: "1rem" }}>
					<Button
						variant='contained'
						sx={{
							backgroundColor: "#800080",
							color: "#fff",
							textTransform: "none",
							padding: "0.75rem 1.5rem",
						}}
						onClick={handleSubmit}>
						Create Client & Send Onboarding Email
					</Button>
					<Button
						variant='outlined'
						sx={{
							textTransform: "none",
							padding: "0.75rem 1.5rem",
						}}
						onClick={closeModal}>
						Search again
					</Button>
				</Box>
			</Box>
		</Modal>
	);
};

export default AddCompanyManuallyModal;
